import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Input, Select, Col, Row, Button, Card, Form, Spin,
} from 'antd';
import { inviteUserDataRequest } from '../redux/actions/invite_user_data.actions';
import { addUserRequest } from '../redux/actions/add_user.actions';
import { validation_rules } from '../../../../shared/validation_rules';

const mapStateToProps = (state) => {
    const { options, loading } = state.UserManagement.User_create.User_create_table;
    return { options, loading };
}; const FormItem = Form.Item; const
    { Option } = Select;

export default connect(mapStateToProps, null)(class User_create_table extends Component {
 state = {
     first_name: '',
     last_name: '',
     ref_prefix_name: '',
     ref_department: '',
     ref_gender: '',
     groups: [],
     login: '',
     password: '',
     extension_number: ' ',
 };

 componentDidMount() {
     this.props.dispatch(inviteUserDataRequest());
 }

  getInputValueHandler = (event, data) => {
      typeof event === 'string'
          ? this.setState({ [data.props.name]: event })
          : this.setState({ [event.target.name]: event.target.value });
  };

  getValuesAsTagsHandler = data => this.setState({ groups: data });

  handleSubmit = (event) => {
      event.preventDefault();
      const {
          first_name, last_name, groups, login, password, extension_number, photos, ref_department, ref_gender, ref_prefix_name,
      } = this.state;
      const user_create_data = {
          person: {
              first_name, last_name, ref_prefix_name, ref_department, ref_gender, photos, extension_number,
          },
          // phones: { name: 'Default Phone Name', extension_number },
          groups,
          login,
          password,
      };
      this.props.dispatch(addUserRequest(user_create_data));
  };

  // fieldsValidation = ({ first_name, last_name, ref_prefix_name, ref_department, ref_gender, groups, login, password, phone  }) => {
  //   return !first_name.length || !last_name.length || !ref_prefix_name.length || !ref_department.length ||
  //          !ref_gender.length || !groups.length || !login.length || !password.length || !phone.length;
  // };

  render() {
      const { options, loading } = this.props; const isDisabled = Object.keys(this.state).some(field => !this.state[field].length);
      const {
          isValueExist, password, email, createUserEmail,
      } = validation_rules;
      return (
          <Spin spinning={loading} tip="Loading...">
              <Col span={24}>
                  <Card className="border-shadows">
                      <Form>
                          <Row>
                              <Col span={10} offset={1}>
                                  <FormItem style={{ marginTop: 20 }} label="Prefix Name">
                                      <Select placeholder="Choose Prefix" onChange={this.getInputValueHandler}>
                                          {options && options.prefixes.map(prefix => <Option key={prefix._id} name="ref_prefix_name" value={prefix._id}>{prefix.name}</Option>)}
                                      </Select>
                                      <span className="createUserValidationError">
                                          {isValueExist(this.state.ref_prefix_name)}
                                      </span>
                                  </FormItem>
                                  <FormItem style={{ marginTop: 20 }} label="First Name">
                                      <Input
                                          allowClear
                                          autoComplete="off"
                                          name="first_name"
                                          placeholder="Enter First Name"
                                          onChange={this.getInputValueHandler}
                                      />
                                      <span className="createUserValidationError">
                                          {isValueExist(this.state.first_name)}
                                      </span>
                                  </FormItem>
                                  <FormItem label="Last Name">
                                      <Input
                                          allowClear
                                          autoComplete="off"
                                          name="last_name"
                                          placeholder="Enter Last Name"
                                          onChange={this.getInputValueHandler}
                                      />
                                      <span className="createUserValidationError">
                                          {isValueExist(this.state.last_name)}
                                      </span>
                                  </FormItem>
                                  <FormItem label="Login">
                                      <Input
                                          name="login"
                                          autoComplete="off"
                                          value={this.state.login}
                                          placeholder="Enter Login"
                                          onChange={this.getInputValueHandler}
                                      />
                                      <span className="createUserValidationError">
                                          {this.state.login
                    && (email(this.state.login) || createUserEmail(this.state.login))}
                                      </span>
                                  </FormItem>
                                  <FormItem label="Password">
                                      <Input.Password
                                          name="password"
                                          placeholder="Enter Login"
                                          onChange={this.getInputValueHandler}
                                      />
                                      <span className="createUserValidationError">
                                          {this.state.password && password(this.state.password)}
                                      </span>
                                  </FormItem>
                              </Col>
                              <Col span={10} offset={1}>
                                  <FormItem style={{ marginTop: 20 }} label="Permission Group">
                                      <Select mode="tags" placeholder="Choose Group" onChange={this.getValuesAsTagsHandler}>
                                          {options && options.roles.map(role => <Option key={role._id} value={role._id}>{role.name}</Option>)}
                                      </Select>
                                      <span className="createUserValidationError">
                                          {isValueExist(this.state.groups)}
                                      </span>
                                  </FormItem>
                                  <FormItem label="Department">
                                      <Select placeholder="Choose Department" onChange={this.getInputValueHandler}>
                                          {options && options.departments.map(department => <Option key={department._id} name="ref_department" value={department._id}>{department.name}</Option>)}
                                      </Select>
                                      <span className="createUserValidationError">
                                          {isValueExist(this.state.ref_department)}
                                      </span>
                                  </FormItem>
                                  <FormItem label="Gender">
                                      <Select placeholder="Choose Gender" onChange={this.getInputValueHandler}>
                                          {options && options.gender.map(gender => <Option key={gender._id} name="ref_gender" value={gender._id}>{gender.name}</Option>)}
                                      </Select>
                                      <span className="createUserValidationError">
                                          {isValueExist(this.state.ref_gender)}
                                      </span>
                                  </FormItem>
                                  <FormItem label="Extension Number">
                                      <Input
                                          allowClear
                                          autoComplete="off"
                                          name="extension_number"
                                          placeholder="Enter Extension Number"
                                          onChange={this.getInputValueHandler}
                                      />
                                      {/* <span className='createUserValidationError'> */}
                                      {/* {!digitAndDashValidation(this.state.extension_number) ? 'This field must contain only digits' : null } */}
                                      {/* </span> */}
                                  </FormItem>
                              </Col>
                          </Row>
                          <div style={{ float: 'right' }}>
                              <Button
                                  type="primary"
                                  disabled={isDisabled
                      || !(!email(this.state.login)
                        // !this.fieldsValidation(this.state) &&
                        // digitAndDashValidation(this.state.extension_number) &&
                        && !createUserEmail(this.state.login)
                        && !password(this.state.password))}
                                  style={{ marginRight: 10 }}
                                  onClick={this.handleSubmit}
                              >
                                  Invite User
                              </Button>
                              <Button type="default"><Link to="/UserManagement/User_list">Back to Users List</Link></Button>
                          </div>
                      </Form>
                  </Card>
              </Col>
          </Spin>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/components/User_create_table.js